import {
  ELEMENT_ATTRIBUTE_GROUP,
  ELEMENT_GROUPS,
  markupDescription
} from './../utils';

const TextElementFields = {
  group: ELEMENT_GROUPS.TEXT,
  label: 'Text Block',
  icon: 'DocumentTextIcon',
  description: 'Adds a text block for free-style text',
  properties: [
    'layout',
    'fontFamily',
    'color',
    'font',
    'alignment',
    'margin',
    'padding',
    {
      label: 'Height',
      name: 'height',
      editor: 'number',
      description: 'The height of the text block',
      default: 45,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Border Bottom Color',
      name: 'borderBottomColor',
      default: '#ffffff',
      editor: 'colorpicker',
      description: 'The bottom border color of the text block',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Background Color',
      name: 'backgroundColor',
      default: '#ffffff',
      editor: 'colorpicker',
      description: 'The background color of the text block',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Border Radius (Top Left)',
      name: 'borderTopLeftRadius',
      editor: 'number',
      description: 'The border radius of the text block at the top left corner',
      default: 10,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Border Radius (Top Right)',
      name: 'borderTopRightRadius',
      editor: 'number',
      description:
        'The border radius of the texg block at the top right corner',
      default: 10,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Border Radius (Bottom Right)',
      name: 'borderBottomRightRadius',
      editor: 'number',
      description:
        'The border radius of the text block at the bottom right corner',
      default: 10,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Border Radius (Bottom Left)',
      name: 'borderBottomLeftRadius',
      editor: 'number',
      description:
        'The border radius of the text block at the bottom left corner',
      default: 10,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Show Drill Down Chevron',
      name: 'showChevron',
      description: 'Shows a chevron at the end of the text. ',
      editor: 'switch',
      default: false,
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'On Press Action',
      name: 'action',
      editor: 'dropdown',
      default: '',
      description: 'An action to run when the text is pressed.',
      options: [],
      function: {
        name: 'getAppActions',
        params: ['app.id']
      },

      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Disable Data Binding',
      name: 'databindingDisabled',
      type: 'boolean',
      description: 'If true, this element will use static data',
      editor: 'switch',
      default: true,
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Binding Source',
      name: 'datasourceId',
      description: 'Choose a content type this element will get its data from',
      editor: 'dropdown',
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      default: '',
      displayWhen: [
        {
          field: 'databindingDisabled',
          operator: '!==',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Binding Field',
      name: 'sourceField',
      editor: 'dropdown',
      description:
        'The field from the underlying datasource will be used as the value of this element',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        values: [],
        params: ['app.id', 'element.datasourceId']
      },
      displayWhen: [
        {
          field: 'databindingDisabled',
          operator: '!==',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Binding Markup',
      name: 'datasourceFieldMarkup',
      editor: 'textbox',
      description: markupDescription,
      default: '',
      options: [],
      displayWhen: [
        {
          field: 'databindingDisabled',
          operator: '!==',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Text',
      name: 'text',
      editor: 'textbox',
      description: 'The test to display in this field',
      default: '',
      options: [],
      displayWhen: [
        {
          field: 'databindingDisabled',
          operator: '==',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    }
  ]
};

export default TextElementFields;
